export default "__VITE_ASSET__oTDayN5O__"